import React from 'react';
import FadeIn from './FadeIn';

const painPoints = [
  'Visiting multiple stores to find everything',
  'Managing long, chaotic grocery lists',
  'Comparing prices across vendors',
  'Spending valuable weekend time on errands',
];

export default function ProblemSection() {
  return (
    <section className="section-spacing bg-muted/40">
      <div className="content-width-wide">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          {/* Image */}
          <FadeIn direction="right" className="md:w-1/2">
            <img
              src="https://images.unsplash.com/photo-1604719312566-8912e9227c6a?auto=format&fit=crop&w=800&q=80"
              alt="Overwhelmed grocery shopper"
              className="rounded-2xl shadow-lg w-full h-72 md:h-80 object-cover"
            />
          </FadeIn>

          {/* Content */}
          <div className="md:w-1/2">
            <FadeIn>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground tracking-tight">
                Why Grocery Shopping Still Feels Difficult
              </h2>
            </FadeIn>
            <FadeIn delay={0.1}>
              <p className="mt-4 text-muted-foreground text-lg leading-relaxed">
                Every month, families face the same exhausting cycle:
              </p>
            </FadeIn>

            <ul className="mt-8 space-y-4">
              {painPoints.map((point, i) => (
                <FadeIn key={i} delay={0.15 + i * 0.08}>
                  <li className="flex items-start gap-3 text-foreground text-base md:text-lg">
                    <span className="mt-1.5 block h-2.5 w-2.5 rounded-full bg-primary/30 flex-shrink-0"></span>
                    {point}
                  </li>
                </FadeIn>
              ))}
            </ul>

            <FadeIn delay={0.5}>
              <p className="mt-8 text-muted-foreground leading-relaxed">
                The traditional grocery process wastes time and energy that could be spent on family, work, or rest.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
}
